import { useUsersContent } from '../../content/sections/users.js';
import { SegmentedControl } from '../filters/segmented-control.js';
import { SearchInput } from '../search-input.js';

/* Estado do filtro de verificação: `all` (padrão) não envia o param; `verified`/`unverified`
   viram o `verified` server-side (a lista não carrega a data de verificação por linha). */
export type VerifiedFilter = 'all' | 'verified' | 'unverified';

interface Props {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly verified: VerifiedFilter;
  readonly onVerifiedChange: (value: VerifiedFilter) => void;
}

/* Toolbar da lista de usuários (ADR-0702/0704): SearchInput + SegmentedControl de verificação
   (server-side). Espaçamento fica a cargo do PageContent (space-y) — sem margens locais. */
export function UsersFilters({ value, onChange, verified, onVerifiedChange }: Props) {
  const copy = useUsersContent();
  /* Montado DENTRO do componente (nunca em escopo de módulo): resolver os labels no load
     congelaria o locale do primeiro import e a troca de idioma não re-renderizaria o texto. */
  const verifiedOptions: readonly { readonly value: VerifiedFilter; readonly label: string }[] = [
    { value: 'all', label: copy.filters.optionAll },
    { value: 'verified', label: copy.filters.optionVerified },
    { value: 'unverified', label: copy.filters.optionUnverified },
  ];
  return (
    <div className="flex flex-wrap items-center gap-3">
      <SearchInput
        value={value}
        onChange={onChange}
        ariaLabel={copy.filters.searchLabel}
        placeholder={copy.filters.searchPlaceholder}
      />
      <SegmentedControl
        ariaLabel={copy.filters.verifiedFilterLabel}
        value={verified}
        onChange={onVerifiedChange}
        options={verifiedOptions}
      />
    </div>
  );
}
